// extracted by mini-css-extract-plugin
export default {"wrapper":"u1iHJ","imgWrapper":"jxsBK","image":"_Guth","titleWrap":"I4DkK","cnImage":"zvecz","title":"R8vJb","count":"lrFUU"};